import React, { Fragment } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import Avatar from 'app/components/molecules/Avatar/Avatar';
import { getWidgetByHeader } from '../dashboardUtils';
import Widget from 'app/components/atoms/Widget/Widget';

const StyledTypography = styled.p`
    color: ${({ theme }) => theme.material.colors.text.secondary};
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.25px;
    margin-top: 0;
    overflow: auto;
    padding: 0 20px;
`;

const StyledAvatar = styled(Avatar)`
    margin-right: 10px;
`;

const renderContent = (content) => {
    const lines = content?.split('\n');
    return (
        <StyledTypography>
            {lines.map((line, index) => (
                <Fragment key={index}>
                    {line}
                    <br />
                </Fragment>
            ))}
        </StyledTypography>
    );
};

const renderAppAvatar = (props) => {
    if (!props) {
        return null;
    }
    return <StyledAvatar size='lg' {...props} />;
};

const StaticWidget = ({ item, menuItemClick, permissions, type }) => {
    const userPermissions = useSelector((state) => state.user?.profile?.permissions);
    const selectedModule = item.selectedModule;
    const { navigationOptions, header, description, avatarProps } = getWidgetByHeader(selectedModule) || {};

    // eslint-disable-next-line prefer-const
    let { link, label } = navigationOptions || {};
    if (header === 'Analytics') {
        if (userPermissions?.includes('analytics.superAnalytics')) {
            link = 'super-analytics';
        } else if (userPermissions?.includes('entity.entity')) {
            link = 'print-reports';
        } else {
            link = 'grafana';
        }
    }

    return (
        <Widget
            key={header}
            title={header}
            content={renderContent(description || '')}
            type={type}
            url={link}
            urlText={label}
            renderAppAvatar={() => renderAppAvatar(avatarProps)} // Pass avatarProps directly
            menuItemClick={menuItemClick}
            permissions={permissions}
            item={item}
        />
    );
};

export default StaticWidget;
